import { API_URL } from "./config";

export function formatCurrency(amount) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount || 0);
}

export function formatDate(dateStr) {
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return date.toLocaleDateString("en-IN");
}

export async function apiRequest(path, options = {}, token) {
  let response;
  try {
    response = await fetch(`${API_URL}${path}`, {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(options.headers || {}),
      },
    });
  } catch (err) {
    if (err?.message?.includes("Failed to fetch") || err?.name === "TypeError") {
      throw new Error("Cannot reach server. Check backend is running on port 5000 and CORS allows your frontend URL.");
    }
    throw new Error("Cannot reach server. Please check backend is running.");
  }

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 404 && !data.message) {
      throw new Error("Not found. Restart the backend server if this is a new feature.");
    }
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}
